// extracted by mini-css-extract-plugin
export default {"search-form":"S_f1 flex-grow-1 form-group mb-0"};